import style from '@aytm/app/stats/page/data-quality-report/styles/Banner.module.scss'

// Promo banner above the section list — "you never pay for removed responses" + guide CTA.
const Banner = () => (
  <div className={style.banner} data-testid="stat-dqr-banner">
    <img className={style.bg} src="/images/data-quality/banner.png" alt="" />
    <span className={style.bgCornerTopLeft} />
    <span className={style.bgCornerTopRight} />
    <span className={style.bgCornerBottomLeft} />
    <span className={style.bgCornerBottomRight} />
    <div className={style.content}>
      <div className={style.heading}>
        <span className={style.headingStrong}>You never pay for the</span>
        <br />
        responses we quarantined or removed from your survey
      </div>
      <a
        data-testid="stat-dqr-banner-cta"
        className="p-component p-button p-button-rounded p-button-bright-blue"
        href="https://aytm.showpad.com/share/mcbhuFrUIzQT513cwcKbj"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-aytmfd-manifesto p-button-icon p-button-icon-left" />
        <span className="p-button-label">Read our Data Quality Guide</span>
      </a>
    </div>
  </div>
)

Banner.displayName = 'Banner'
export default Banner
